import { ApiPropertyOptional } from '@nestjs/swagger'
import { IsOptional, IsUUID, IsString } from 'class-validator'
import { OffsetPaginationQueryDto } from '@sphere/shared/domain'

/**
 * DTO pour la query de liste de classes avec pagination et filtres
 */
export class ClassQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    description: 'Filtrer par établissement (UUID)',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  establishmentId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par niveau (External ID)',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  levelExternalId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par section (UUID)',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  sectionId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par statut (UUID)',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  statusId?: string

  @ApiPropertyOptional({
    description: 'Filtrer par année scolaire (UUID)',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string

  @ApiPropertyOptional({
    description:
      "Inclure des données supplémentaires (ex: 'groups' pour groupIds)",
    example: 'groups',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  include?: string
}

/**
 * DTO pour la query de liste des membres d'une classe
 */
export class ClassMembershipQueryDto extends OffsetPaginationQueryDto {
  @ApiPropertyOptional({
    description: 'Filtrer par groupe (UUID)',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  groupId?: string
}

// Backward compatibility alias
export class ListClassesQueryDto extends OffsetPaginationQueryDto {}
